<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-9">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t("doc.product.Features") }}</p>
                            <img src="../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow" />
                            <a href="#">{{ $t("doc.product.MultilingualSupport") }}</a>
                        </div>
                        <div class="according-menu">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            <p>On this page</p>
                                            <span class="down_up_icon"><img src="/img/up_arrow_side.7f2fb856.svg"
                                                    alt="" /></span>
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="tableOfContents-list">
                                                <ul id="side_section_info">
                                                    <li :class="{
                                                        active_menu_item:
                                                            rightPanelMenuItem === '#opening-the-command-bar-link',
                                                    }">
                                                        <a @click="scrollTo('#supported-languages')" class="link_wrp">{{
                                                            $t("features.Multilingual.supportLanguage") }}</a>
                                                    </li>
                                                    <li :class="{
                                                        active_menu_item:
                                                            rightPanelMenuItem ===
                                                            '#Update-language-in-the-live-chat-widget-link',
                                                    }">
                                                        <a @click="
                                                            scrollTo('#Update-language-in-the-live-chat-widget')
                                                            " class="link_wrp">{{$t("features.Multilingual.updateLanguageinLiveChat")  }}</a>
                                                    </li>
                                                    <li :class="{
                                                                active_menu_item:
                                                                    rightPanelMenuItem === '#update-language-link',
                                                            }">
                                                        <a @click="scrollTo('#update-language')" class="link_wrp">{{
                                                            $t("features.Multilingual.updateLanguageInDashboard")
                                                        }}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="Introduction-details">
                            <div class="canned_list_wrp">
                                <h1>{{ $t("doc.product.MultilingualSupport") }}</h1>
                                <p>{{ $t("features.Multilingual.updateLanguageInDashboardDesc") }}</p>
                            </div>

                            <div class="canned_list_wrp" id="supported-languages">
                                <h3>{{ $t("features.Multilingual.supportLanguage") }}</h3>
                                <p>
                                    {{ $t("features.Multilingual.languageSupported") }}
                                    <a href="https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes" target="_blank"
                                        rel="noopener noreferrer">{{ $t("features.Multilingual.numberData") }}</a>).
                                </p>
                            </div>

                            <div class="table_wrp">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Language</th>
                                            <th>Short Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>English (en)</td>
                                            <td>en</td>
                                        </tr>
                                        <tr>
                                            <td>العربية (ar)</td>
                                            <td>ar</td>
                                        </tr>
                                        <tr>
                                            <td>Nederlands (nl)</td>
                                            <td>nl</td>
                                        </tr>
                                        <tr>
                                            <td>Français (fr)</td>
                                            <td>fr</td>
                                        </tr>
                                        <tr>
                                            <td>Deutsch (de)</td>
                                            <td>de</td>
                                        </tr>
                                        <tr>
                                            <td>हिन्दी (hi)</td>
                                            <td>hi</td>
                                        </tr>
                                        <tr>
                                            <td>Italiano (it)</td>
                                            <td>it</td>
                                        </tr>
                                        <tr>
                                            <td>한국어 (ko)</td>
                                            <td>ko</td>
                                        </tr>
                                        <tr>
                                            <td>Português (pt)</td>
                                            <td>pt</td>
                                        </tr>
                                        <tr>
                                            <td>русский (ru)</td>
                                            <td>ru</td>
                                        </tr>
                                        <tr>
                                            <td>中文 (zh)</td>
                                            <td>zh</td>
                                        </tr>
                                        <tr>
                                            <td>Español (es)</td>
                                            <td>es</td>
                                        </tr>
                                        <tr>
                                            <td>മലയാളം (ml)</td>
                                            <td>ml</td>
                                        </tr>
                                        <tr>
                                            <td>Català (ca)</td>
                                            <td>ca</td>
                                        </tr>
                                        <tr>
                                            <td>ελληνικά (el)</td>
                                            <td>el</td>
                                        </tr>
                                        <tr>
                                            <td>Português Brasileiro (pt-BR)</td>
                                            <td>pt_BR</td>
                                        </tr>
                                        <tr>
                                            <td>Română (ro)</td>
                                            <td>ro</td>
                                        </tr>
                                        <tr>
                                            <td>தமிழ் (ta)</td>
                                            <td>ta</td>
                                        </tr>

                                        <tr>
                                            <td>فارسی (fa)</td>
                                            <td>fa</td>
                                        </tr>

                                        <tr>
                                            <td>中文 (台湾) (zh-TW)</td>
                                            <td>zh_TW</td>
                                        </tr>
                                        <tr>
                                            <td>Tiếng Việt (vi)</td>
                                            <td>vi</td>
                                        </tr>
                                        <tr>
                                            <td>dansk (da)</td>
                                            <td>da</td>
                                        </tr>

                                        <tr>
                                            <td>Türkçe (tr)</td>
                                            <td>tr</td>
                                        </tr>

                                        <tr>
                                            <td>čeština (cs)</td>
                                            <td>cs</td>
                                        </tr>

                                        <tr>
                                            <td>suomi, suomen kieli (fi)</td>
                                            <td>fi</td>
                                        </tr>

                                        <tr>
                                            <td>Bahasa Indonesia (id)</td>
                                            <td>id</td>
                                        </tr>

                                        <tr>
                                            <td>Svenska (sv)</td>
                                            <td>sv</td>
                                        </tr>

                                        <tr>
                                            <td>magyar nyelv (hu)</td>
                                            <td>hu</td>
                                        </tr>

                                        <tr>
                                            <td>norsk (no)</td>
                                            <td>no</td>
                                        </tr>

                                        <tr>
                                            <td>中文 (zh-CN)</td>
                                            <td>zh_CN</td>
                                        </tr>

                                        <tr>
                                            <td>język polski (pl)</td>
                                            <td>pl</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="canned_list_wrp" id="Update-language-in-the-live-chat-widget">
                                <h3>{{ $t("features.Multilingual.updateLanguageinLiveChat") }}</h3>
                                <p>
                                    {{ $t("features.Multilingual.asDescribed") }}
                                    <a href="/docs/product/channels/live-chat/sdk/setup">{{
                                        $t("features.Multilingual.SDKSetupGuide")
                                    }}</a>
                                    {{ $t("features.Multilingual.configureLiveChat") }}
                                    <code>{{ $t("doc.SDKSetup.enablePopoutWindow.bcoorSettings") }}</code>
                                    {{ $t("features.Multilingual.calling") }}
                                    <code>{{ $t("doc.SDKSetup.customAttributes.setLocale") }}</code>
                                    {{ $t("features.Multilingual.provideShortCode") }}
                                </p>
                            </div>

                            <div class="codeBlockContainer_I0IT language-js theme-code-block">
                                <div class="codeBlockContent_wNvx"
                                    style="color: rgb(191, 199, 213); background-color: rgb(41, 45, 62)">
                                    <pre tabindex="0"
                                        class="prism-code language-js codeBlock_jd64 thin-scrollbar"><code class="codeBlockLines_mRuA"><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// Pass via window.bcoorSettings</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token dom variable" style="color: rgb(191, 199, 213);">window</span><span class="token punctuation" style="color: rgb(199, 146, 234);">.</span><span class="token property-access">bcoorSettings</span><span class="token plain"> </span><span class="token operator" style="color: rgb(137, 221, 255);">=</span><span class="token plain"> </span><span class="token punctuation" style="color: rgb(199, 146, 234);">{</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  </span><span class="token literal-property property">locale</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token string" style="color: rgb(195, 232, 141);">'pt_BR'</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  </span><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// .. rest of the settings</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token punctuation" style="color: rgb(199, 146, 234);">}</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain" style="display: inline-block;"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// Using setLocale method</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token dom variable" style="color: rgb(191, 199, 213);">window</span><span class="token punctuation" style="color: rgb(199, 146, 234);">.</span><span class="token property-access">$bcoor</span><span class="token punctuation" style="color: rgb(199, 146, 234);">.</span><span class="token method function property-access" style="color: rgb(130, 170, 255);">setLocale</span><span class="token punctuation" style="color: rgb(199, 146, 234);">(</span><span class="token string" style="color: rgb(195, 232, 141);">'pt_BR'</span><span class="token punctuation" style="color: rgb(199, 146, 234);">)</span><br></span></code></pre>
                                </div>
                            </div>

                            <div class="canned_list_wrp" id="update-language">
                                <h3>{{
                                    $t("features.Multilingual.updateLanguageInDashboard")
                                }}</h3>
                                <p>
                                    To update the language in the dashboard, log in as an administrator.
                                    Click on the
                                    <strong>Settings</strong>, navigate to
                                    <strong>Account Settings</strong>. You will be able to see the
                                    <strong>Site Language</strong> setting available in the options. Change
                                    it to the language of your choice. Click on the
                                    <strong>Update Settings</strong> button.
                                </p>

                                <p class="widget_wrp">
                                    <img src="../../../../assets/images/account-settings-multi.webp" class="img-fuild" />
                                </p>

                                <p>
                                    <strong>Note:</strong> Changing the language as per the above
                                    instruction would change the default language for all
                                    agents/administrators in the system. At the moment, bcoor does not
                                    support language selection at the agent level. Also, note that this
                                    language would be used as the fallback language for the live-chat
                                    widget.
                                </p>
                            </div>

                            <div class="update_edit_wrp">
                                <!-- <div class="edit_wrp">
                                    <a href="#">
                                        <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40"
                                            class="iconEdit_dcUD" aria-hidden="true">
                                            <g>
                                                <path
                                                    d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                                </path>
                                            </g>
                                        </svg>

                                        <p>Edit this page</p>
                                    </a>
                                </div> -->

                                <div class="update_wrp">
                                    <p>Last updated on <b>10/3/2021</b> by <b>Pranav Raj S</b></p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="create-chat-woot-account create-chat-previous">
                                        <p>Previous</p>
                                        <a href="/docs/user-guide/features/template-variables"><span>«</span>Template
                                            variables</a>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="create-chat-woot-account">
                                        <p>Next</p>
                                        <a href="/docs/user-guide/features/reports/concepts">Main Concepts<span>»</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <section class="tableOfContents">
                            <div class="tableOfContents-list">
                                <ul id="side_section_info">
                                    <li :class="{
                                                active_menu_item:
                                                    rightPanelMenuItem === '#supported-languages-link',
                                            }">
                                        <a id="#supported-languages-link" @click="scrollTo('#supported-languages')"
                                            class="link_wrp">Supported language</a>
                                    </li>

                                    <li :class="{
                                        active_menu_item:
                                            rightPanelMenuItem ===
                                            '#Update-language-in-the-live-chat-widget-link',
                                    }">
                                        <a id="#Update-language-in-the-live-chat-widget-link"
                                            @click="scrollTo('#Update-language-in-the-live-chat-widget')"
                                            class="link_wrp">Update language in the live-chat widget</a>
                                    </li>
                                    <li :class="{
                                        active_menu_item: rightPanelMenuItem === '#update-language-link',
                                    }">
                                        <a id="#update-language-link" @click="scrollTo('#update-language')"
                                            class="link_wrp">Update language in the dashboard</a>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SideBar from "@/components/SideBar.vue";
// import MainContent from "@/components/MainContent.vue";

export default {
    name: "ios",
    data() {
        return {
            isToggle: false,
            activeMenuItem: null,
            rightPanelMenuItem: null,
        };
    },
    components: {
        Header,
        Footer,
        SideBar,
        // MainContent
    },
    mounted() {
        window.addEventListener("scroll", this.setActiveMenuItem);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.setActiveMenuItem);
    },
    methods: {
        scrollTo(selector) {
            const element = document.querySelector(selector);
            if (element) {
                const offset = 106;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
                this.rightPanelMenuItem = `${selector}-link`;
            }
        },
        setActiveMenuItem() {
            const scrollPosition = window.scrollY;
            const menuItems = document.querySelectorAll("#side_section_info li");
            this.activeMenuItem = null;
            for (let i = menuItems.length - 1; i >= 0; i--) {
                const menuItem = menuItems[i];
                // console.log(menuItem)
                const target = document.querySelector(
                    menuItem
                        .querySelector("a")
                        .getAttribute("id")
                        ?.replace(/-link(?=[^-]*$)/, "")
                );
                if (target?.offsetTop - 200 <= scrollPosition) {
                    let tempEle;
                    if (menuItem) {
                        tempEle = menuItem?.getAttribute("id");
                        let targetID = target?.getAttribute("id");
                        this.rightPanelMenuItem = `#${targetID}-link`;
                        // menuItem?.classList.add("active_menu_item");
                    }
                    this.activeMenuItem = tempEle;
                    return;
                }
            }
        },
        handleToggle() {
            this.isToggle = !this.isToggle;
        },
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}
</style>